const StatusToggle = ({ checked, onChange, disabled = false }) => (
    <div className="inline-flex p-1 rounded-full bg-charleston-green border border-zinc-700 self-start">
        <button
            type="button"
            disabled={disabled}
            onClick={() => onChange(true)}
            className={`px-4 py-1 text-xs rounded-full transition-colors ${
                checked
                    ? "bg-green-950 text-green-500 border border-green-500"
                    : "text-zinc-500 hover:text-white border border-transparent"
            }`}
        >
            ACTIVE
        </button>
        <button
            type="button"
            disabled={disabled}
            onClick={() => onChange(false)}
            className={`px-4 py-1 text-xs rounded-full transition-colors ${
                !checked
                    ? "bg-red-950 text-red-500 border border-red-500"
                    : "text-zinc-500 hover:text-white border border-transparent"
            }`}
        >
            INACTIVE
        </button>
    </div>
);

export default StatusToggle;
